import React, { useEffect, useRef } from "react";
import { X, Download } from "lucide-react";

export default function FilePreviewModal({ blobUrl, fileName, onClose }) {
  const overlayRef = useRef(null);

  useEffect(() => {
    const handleKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [onClose]);

  const handleOverlayClick = (e) => {
    if (e.target === overlayRef.current) onClose();
  };

  const handleDownload = () => {
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = fileName || "file.jpg";
    a.click();
  };

  return (
    <div
      ref={overlayRef}
      onClick={handleOverlayClick}
      className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4"
      data-testid="file-preview-modal"
    >
      <div className="bg-white rounded-sm shadow-xl max-w-3xl w-full max-h-[90vh] flex flex-col overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 border-b border-slate-100 flex-shrink-0">
          <p className="text-sm font-semibold text-[#0F172A] truncate font-[Manrope]">{fileName || "Preview File"}</p>
          <div className="flex items-center gap-2">
            <button
              onClick={handleDownload}
              title="Unduh file"
              className="p-1.5 text-[#475569] hover:text-[#002147] hover:bg-slate-100 rounded-sm transition-all"
            >
              <Download size={16} />
            </button>
            <button
              onClick={onClose}
              data-testid="close-preview-btn"
              className="p-1.5 text-[#475569] hover:text-red-600 hover:bg-red-50 rounded-sm transition-all"
            >
              <X size={16} />
            </button>
          </div>
        </div>

        {/* Image */}
        <div className="flex-1 overflow-auto flex items-center justify-center p-4 bg-slate-50">
          <img
            src={blobUrl}
            alt={fileName}
            className="max-w-full max-h-[70vh] object-contain rounded-sm shadow"
            data-testid="preview-image"
          />
        </div>
      </div>
    </div>
  );
}
